var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('BContainer',{staticClass:"content"},[(_vm.isLoggedIn)?_c('section',{staticClass:"row g-4"},[(!_vm.isNullUser & !_vm.isAdmin)?_c('LeftMenu'):_vm._e(),_c('div',{staticClass:"col-lg-9"},[_c('RouterView')],1)],1):_c('section',[_c('RouterView')],1)]),_c('Modals'),(_vm.isLoggedIn)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }